'use client';

import { use } from 'react';
import { RecentSearchCarouselSlide } from './RecentSearchCarouselSlide';
import type { RecentSearchCarouselItem } from './types/RecentSearchCarouselItem';
export type RecentSearchSliderProps = {
  recentSearches: Promise<RecentSearchCarouselItem[]>;
};
export function RecentSearchCarouselSlides({
  recentSearches: recentSearchesIn
}: RecentSearchSliderProps) {
  const recentSearches = use(recentSearchesIn);
  return recentSearches.map(recentSearch => <RecentSearchCarouselSlide key={recentSearch.suid} recentSearch={recentSearch} />);
}